
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 20"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"currentColor","fill-rule":"evenodd","d":"M15 11.667c.46 0 .833.373.833.833v1.666H17.5a.834.834 0 010 1.667h-1.667V17.5a.833.833 0 01-1.666 0v-1.667H12.5a.833.833 0 010-1.666h1.667V12.5c0-.46.373-.833.833-.833zM7.023 2.394c.46.124.868.35 1.209.65 1.024-.04 2.04.822 2.38 2.094.245.919.08 1.828-.373 2.443.186.241.253.62.15 1.004-.086.322-.273.58-.496.724a3.257 3.257 0 01-1.318 2.205 1.037 1.037 0 01-.156.093l.16.487c.325.973.636 1.76 1.469 2.213a4.982 4.982 0 00.621 3.193H0c0-1.274.834-2.397 2.052-2.763l.689-.207c1.428-.43 1.71-1.528 2.174-2.923a1.001 1.001 0 01-.157-.093A3.257 3.257 0 013.44 9.309c-.223-.143-.41-.402-.496-.724-.126-.469.002-.928.288-1.142a3.642 3.642 0 01-.215-2.513c.498-1.86 2.291-2.996 4.006-2.536zm6.667 0c.46.124.868.35 1.209.65 1.024-.04 2.039.822 2.38 2.094.245.919.08 1.828-.373 2.443.186.241.253.62.15 1.004-.086.322-.273.58-.496.724a3.257 3.257 0 01-.242.867A4.985 4.985 0 0015 10a4.984 4.984 0 00-3.58 1.51l.005.004a3.25 3.25 0 01-.966-1.11c.081-.2.147-.41.195-.625l.006-.028.028-.027a2.16 2.16 0 00.506-.923l.017-.066c.082-.35.08-.708-.007-1.035l-.02-.072.012-.025c.386-.782.47-1.746.22-2.68l-.02-.074a4.019 4.019 0 00-.817-1.523c.805-.842 1.975-1.237 3.11-.932z"}})])
          )
        }
      }
    